import styled from 'styled-components';

const searchComboOpen = s3BasePath => ({
  backgroundImage: `url(${s3BasePath}mkt/search_combo_open.jpg)`,
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  cursor: 'pointer',
  height: '25px',
  position: 'absolute',
  right: 0,
  width: '25px',
});

const SortAndPaginationWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
`;

const SortByLabel = styled.span`
  height: 25px;
  line-height: 25px;
  text-transform: uppercase;
  margin-right: 10px;
  font-family: 'Avenir Light', 'Arial', sans-serif;
  font-weight: 900;
  color: #000;
  font-size: 15px;
  margin-bottom: 0px;
  margin-top: 1px;
`;

const SortBySelect = styled.select`
  line-height: normal;
  height: 25px;
  padding: 0px;
  margin: 0px;
  width: 235px;
  visibility: visible;
`;

const SortByWrapper = styled.div`
  display: flex;
  flex-direction: row;

  & .jNiceWrapper .jNiceSelectWrapper {
    height: 25px;
    line-height: 25px;
    background-color: #000;
  }

  & .jNiceWrapper .jNiceSelectWrapper .jNiceSelectText {
    height: 25px;
    line-height: 25px;
    color: #fff;
    padding: 0px;
    font-size: 13px;
    text-indent: 10px;
    background-color: #000;
    font-family: 'Avenir Light', 'Arial', sans-serif;
    font-weight: 900;
    font-style: normal;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  & .jNiceWrapper .jNiceSelectWrapper .jNiceSelectText font {
    color: #b3b3b3;
  }

  & .jNiceWrapper .jNiceSelectWrapper:hover .jNiceSelectText,
  & .jNiceWrapper .jNiceSelectWrapper:hover .jNiceSelectOpen {
  }

  & .jNiceWrapper .selected .jNiceSelectText,
  & .jNiceWrapper .selected .jNiceSelectOpen {
  }

  & .jNiceWrapper .jNiceSelectWrapper ul {
    top: 25px;
    border: 0px;
    width: 255px;
    left: 0px;
    height: auto;
    background-color: #000;
    padding-top: 0px;
  }

  & .jNiceWrapper .jNiceSelectWrapper ul li {
    float: left;
    padding: 0px;
    width: 100%;
    height: auto;
  }

  & .jNiceWrapper .jNiceSelectWrapper ul li a {
    float: left;
    padding: 0px;
    padding-top: 7px;
    padding-bottom: 7px;
    display: inline;
    padding-left: 10px;
    padding-right: 10px;
    width: 235px;
    background: none;
    color: #fff;
    height: auto;
    font-size: 13px;
    line-height: 15px;
    text-transform: uppercase;
    font-family: 'Avenir Light', 'Arial', sans-serif;
    letter-spacing: 1px;
    font-weight: 900;
    text-decoration: none;
  }

  & .jNiceWrapper .jNiceSelectWrapper ul li a:hover,
  & .jNiceWrapper .jNiceSelectWrapper ul li a.selected {
    background-color: #f5f5f5;
    color: #000;
    background-image: none;
  }
`;

const CurrentPage = styled.input`
  appearance: none;
  background-color: #ffffff;
  border-radius: 4px !important;
  border: 1px solid #000000 !important;
  box-shadow: inset 0 1px 3px 0 rgba(153, 153, 153, 0.5), 0 1px 1px 0 rgba(221, 221, 221, 0.5);
  color: #000000;
  font-family: Pathway Gothic One;
  font-size: 16px;
  height: 38px;
  margin: 0 5px !important;
  outline-offset: 0 !important;
  outline: none !important;
  text-align: center;
  width: 48px;
  &:focus {
    outline: none !important;
    outline-offset: 0 !important;
  }
`;

const PrevPage = styled.div`
  color: #000000;
  cursor: pointer;
  display: inline-block;
  font-family: Pathway Gothic One;
  font-size: 16px;
  margin-right: 20px;
  text-decoration: underline;
`;

const TriangleLeft = styled.div`
  border-bottom: 8px solid transparent;
  border-right: 9px solid #000000;
  border-top: 8px solid transparent;
  cursor: pointer;
  display: inline-block;
  height: 0;
  margin: 0 5px -3px 0;
  width: 0;
`;

const NextPage = styled.div`
  color: #000000;
  cursor: pointer;
  display: inline-block;
  font-family: Pathway Gothic One;
  font-size: 16px;
  margin-left: 20px;
  text-decoration: underline;
`;

const TriangleRight = styled.div`
  border-bottom: 8px solid transparent;
  border-left: 9px solid #000000;
  border-top: 8px solid transparent;
  cursor: pointer;
  display: inline-block;
  height: 0;
  margin: 0 0 -3px 5px;
  width: 0;
`;

const PaginationWrapper = styled.div`
  ${props =>
    props.align
      ? `text-align: ${props.align};
       margin-top: 30px;`
      : null} margin-bottom: 10px;
`;

const PaginationList = styled.ul`
  float: right;
  display: inline-block;
  margin-left: 0;
  margin-bottom: 0;
  border-radius: 3px;

  & li:last-child {
    border: 0px;
  }
`;

const PaginationElement = styled.li`
  display: inline-block;
  height: 18px;
  border-radius: 0px;
  border-left-width: 1px;
  background-color: #fff;
  color: #000;
  border: 0px;
  border-right: 1px solid #000;
  font-family: 'Avenir Light', 'Arial', sans-serif;
  font-weight: 900;
  font-size: 13px;

  & a {
    display: inline-block;
    height: 18px;
    line-height: 22px;
    padding: 0 5px;
    text-decoration: none;
    cursor: pointer;
    ${props =>
      props.active
        ? `
      background-color: #000;
      color: #FFF;
    `
        : 'color: #000;'};
  }

  & a:hover {
    background-color: #000;
    color: #fff;
  }

  & span {
    padding: 0 5px;
  }
`;

const PaginationElementActive = styled(PaginationElement)`
  background-color: #000;
  color: #fff;
`;

const TotalPages = styled.span`
  color: #000000;
  cursor: pointer;
  font-family: Pathway Gothic One;
  font-size: 16px;
  &:hover {
    text-decoration: underline;
  }
`;

const TotalProductsCountAndSearchKeyword = styled.div`
  color: #000000;
  font-family: Pathway Gothic One;
  font-size: 16px;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export {
  searchComboOpen,
  CurrentPage,
  NextPage,
  PaginationWrapper,
  PaginationElement,
  PaginationElementActive,
  PaginationList,
  PrevPage,
  SortAndPaginationWrapper,
  SortByLabel,
  SortBySelect,
  SortByWrapper,
  TotalPages,
  TotalProductsCountAndSearchKeyword,
  TriangleLeft,
  TriangleRight,
};
